import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { Alert, IconButton, Typography } from '@mui/material';

export function PublicSignerRequiredFieldBanner({
  onDismiss
}: {
  onDismiss: () => void;
}) {
  return (
    <Alert
      data-testid="public-signer-required-field-banner"
      icon={<ErrorOutlineRoundedIcon fontSize="small" />}
      role="alert"
      severity="error"
      action={
        <IconButton
          aria-label="Dismiss required field warning"
          color="inherit"
          onClick={onDismiss}
          size="small"
        >
          <CloseRoundedIcon fontSize="small" />
        </IconButton>
      }
      sx={{
        alignItems: 'center',
        borderRadius: 0,
        flex: '0 0 auto'
      }}
    >
      <Typography component="span" sx={{ fontWeight: 600 }} variant="body2">
        This field is required.
      </Typography>
    </Alert>
  );
}
